import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a", amberText: "#92400e",
  blue: "#2563eb", blueBg: "#eff6ff", blueBorder: "#bfdbfe",
  serif: "'Instrument Serif', Georgia, serif",
  sans:  "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:     <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:    <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    ChevronRight:  <><path d="m9 18 6-6-6-6"/></>,
    ChevronDown:   <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:     <><path d="m18 15-6-6-6 6"/></>,
    Search:        <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:        <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:          <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    BadgeCheck:    <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Calendar:      <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Clock:         <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Wallet:        <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    ShieldCheck:   <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Home:          <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    Sparkles:      <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    Shirt:         <><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></>,
    Brush:         <><path d="M9.06 11.9l8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"/><path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"/></>,
    Droplets:      <><path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"/><path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"/></>,
    Sofa:          <><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z"/><path d="M4 18v2M20 18v2"/></>,
    Building:      <><rect width="16" height="20" x="4" y="2" rx="2"/><path d="M9 22v-4h6v4M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01"/></>,
    Truck:         <><path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3"/><rect width="7" height="7" x="14" y="10" rx="1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></>,
    Filter:        <><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></>,
    SlidersH:      <><line x1="21" y1="4" x2="14" y2="4"/><line x1="10" y1="4" x2="3" y2="4"/><line x1="21" y1="12" x2="12" y2="12"/><line x1="8" y1="12" x2="3" y2="12"/><line x1="21" y1="20" x2="16" y2="20"/><line x1="12" y1="20" x2="3" y2="20"/><line x1="14" y1="2" x2="14" y2="6"/><line x1="8" y1="10" x2="8" y2="14"/><line x1="16" y1="18" x2="16" y2="22"/></>,
    User:          <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */

const SUBSERVICES = [
  { icon: "Home",     label: "Home cleaning",          range: "KES 1,200 – 5,000",  note: "per session" },
  { icon: "Sofa",     label: "Deep cleaning",          range: "KES 2,500 – 8,000",  note: "per visit" },
  { icon: "Shirt",    label: "Laundry & ironing",      range: "KES 500 – 2,000",    note: "per load" },
  { icon: "Sparkles", label: "Move-in / move-out clean", range: "KES 3,000 – 9,000", note: "per property" },
  { icon: "Building", label: "Office & commercial",     range: "KES 4,000 – 15,000", note: "per visit" },
  { icon: "Brush",    label: "Upholstery & carpet",     range: "KES 1,500 – 6,000",  note: "per item/room" },
];

const HOW_IT_WORKS = [
  { num: "01", icon: "Search",   title: "Tell us what you need",     desc: "Choose your cleaning type, your home size, and your preferred date. Takes under a minute." },
  { num: "02", icon: "User",     title: "Compare verified Pros",     desc: "See ratings, reviews, pricing, and availability for cleaners near you before you choose." },
  { num: "03", icon: "Calendar", title: "Book and confirm",          desc: "Pick a time slot, confirm any access details, and your cleaner is notified instantly." },
  { num: "04", icon: "Wallet",   title: "Pay securely after",        desc: "Your payment is held safely and released to the Pro only once the job is done to your standard." },
];

const WHY_POINTS = [
  { icon: "BadgeCheck",  title: "Every cleaner is verified",    desc: "ID-checked and background-reviewed before they ever appear in search results. No exceptions." },
  { icon: "Star",        title: "Reviews tied to real bookings", desc: "Every rating comes from a completed, paid booking. No anonymous or fake reviews ever make it onto a profile." },
  { icon: "ShieldCheck", title: "Covered by the Jirani Guarantee", desc: "If a job is not done to standard, our Trust and Safety team reviews and resolves it, including refunds where warranted." },
  { icon: "Wallet",      title: "Pay only when satisfied",       desc: "Funds are held securely and only released to the Pro after you confirm the work meets what was agreed." },
];

const FAQS = [
  {
    q: "How much does house cleaning cost in Kenya through JiraniApp?",
    a: "Standard home cleaning typically ranges from KES 1,200 to 5,000 per session depending on the size of your home and the scope of work. A studio or one-bedroom unit sits at the lower end; a four-bedroom house with a full deep clean sits at the higher end. Every JiraniPro lists their own rates clearly on their profile before you book, so you always know the price before confirming.",
  },
  {
    q: "What is the difference between a standard clean and a deep clean?",
    a: "A standard clean covers the regular upkeep of a home: floors, surfaces, bathrooms, kitchen, and general tidying. A deep clean goes further, addressing buildup in less-frequently cleaned areas such as behind appliances, inside cabinets, skirting boards, window tracks, and grout. Most clients book a deep clean every few months and a standard clean weekly or biweekly in between.",
  },
  {
    q: "Do I need to provide cleaning supplies and equipment?",
    a: "Most JiraniPros bring their own cleaning supplies and equipment as part of their service, and this is usually noted on their profile. Some Pros offer a discounted rate if you provide your own supplies. Always check the specific Pro's profile or ask via in-app message before booking to confirm what is included.",
  },
  {
    q: "Can I book a recurring cleaning schedule?",
    a: "Yes. Once you find a JiraniPro you are happy with, you can set up recurring bookings — weekly, biweekly, or monthly — directly through their profile. Recurring clients often build a working relationship with their cleaner, which means fewer instructions needed each time and more consistent results.",
  },
  {
    q: "What happens if I am not satisfied with the cleaning?",
    a: "Walk through the space with the Pro before they leave and raise anything that does not meet what was agreed — most issues are resolved on the spot. If something is missed after they have left, message the Pro directly through the app. If it cannot be resolved between you, you can open a dispute through Help and Support within 48 hours, and our team will review it fairly.",
  },
  {
    q: "Is laundry service separate from house cleaning?",
    a: "Yes, though many JiraniPros offer both. Laundry and ironing is typically priced per load or per kilogram rather than per session. If you want both house cleaning and laundry handled by the same person, look for Pros who list both services on their profile, or ask directly if they can accommodate it.",
  },
];

const TESTIMONIALS = [
  { name: "Wanjiru K.", area: "Kileleshwa, Nairobi", text: "I have used the same JiraniPro for deep cleaning every six weeks for almost a year now. She knows exactly how I like things done and I do not even need to give instructions anymore.", rating: 5 },
  { name: "Omar S.",    area: "Nyali, Mombasa",       text: "Booked a move-out clean before handing back my rental. The Pro was thorough, photographed everything, and my landlord had zero complaints about the deposit.", rating: 5 },
  { name: "Brenda A.",  area: "Westlands, Nairobi",   text: "The laundry and ironing service has genuinely given me back hours every week. Drop it off, get it back folded and pressed. Simple.", rating: 5 },
];

/* ─────────────────────────────────────────
   COMPONENTS
───────────────────────────────────────── */

function SubServiceCard({ icon, label, range, note }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "20px 18px", borderRadius: 14,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .18s", cursor: "default",
      }}>
      <div style={{
        width: 38, height: 38, borderRadius: 10,
        background: hovered ? T.g100 : T.n50,
        border: `1px solid ${hovered ? T.g200 : T.n150}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 14, transition: "all .18s",
      }}>
        <Icon name={icon} size={17} color={hovered ? T.g600 : T.n400} strokeWidth={1.7} />
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 7 }}>{label}</div>
      <div style={{ fontFamily: T.serif, fontSize: 19, fontWeight: 400, color: hovered ? T.g700 : T.n900, letterSpacing: "-0.02em", lineHeight: 1.2 }}>{range}</div>
      <div style={{ fontSize: 11, color: T.n400, marginTop: 3 }}>{note}</div>
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", textAlign: "left", background: "none", border: "none",
        padding: "22px 0", display: "flex", justifyContent: "space-between",
        alignItems: "center", cursor: "pointer", gap: 20, fontFamily: T.sans,
      }}>
        <span style={{ fontSize: 15, fontWeight: 400, color: T.n800, lineHeight: 1.5, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{
          width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
          border: `1px solid ${open ? T.g500 : T.n200}`,
          background: open ? T.g500 : "transparent",
          color: open ? T.white : T.n400,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .22s cubic-bezier(.4,0,.2,1)",
          transform: open ? "rotate(45deg)" : "none",
          fontSize: 18, fontWeight: 300, lineHeight: 1,
        }}>+</span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 400 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ margin: "0 0 22px", fontSize: 15, color: T.n600, lineHeight: 1.75, paddingRight: 48, fontFamily: T.sans }}>{a}</p>
      </div>
    </div>
  );
}

function TestimonialCard({ name, area, text, rating }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  return (
    <div style={{ padding: "22px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", gap: 2 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Icon key={i} name="Star" size={13} color={i < rating ? T.amber : T.n150} strokeWidth={0} />
        ))}
      </div>
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>"{text}"</p>
      <div style={{ display: "flex", alignItems: "center", gap: 10, paddingTop: 6, borderTop: `1px solid ${T.n100}` }}>
        <div style={{ width: 34, height: 34, borderRadius: "50%", background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 600, color: T.g700, fontFamily: T.sans }}>{initials}</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 11, color: T.n400 }}>{area}</div>
        </div>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function CleaningCategoryPage() {
  useFonts();
  const navigate = useNavigate();
  const [location, setLocation] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);

  const goToSearch = () => {
    const params = location.trim() ? `?category=cleaning&location=${encodeURIComponent(location.trim())}` : "?category=cleaning";
    navigate(`/search${params}`);
  };

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 60 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/pro-onboarding")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: `1px solid ${T.n200}`, cursor: "pointer",
          color: T.n600, fontSize: 13, fontFamily: T.sans,
          padding: "8px 16px", borderRadius: 8, fontWeight: 500,
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.n400; e.currentTarget.style.color = T.n900; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          Offer cleaning services? Join as a Pro
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(40px,5vw,56px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="Sparkles" size={13} color={T.g500} strokeWidth={2.2} />
            Cleaning &amp; Laundry
          </div>
          <h1 style={{
            fontFamily: T.serif, fontSize: "clamp(38px,7vw,64px)", fontWeight: 400,
            margin: "0 0 18px", lineHeight: 1.07, color: T.n900, letterSpacing: "-0.03em", maxWidth: 600,
          }}>
            A spotless home,<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>without the hassle</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 32px", maxWidth: 520 }}>
            Book verified, reviewed cleaning and laundry professionals across Kenya. Compare prices,
            check availability, and have your space looking its best — usually within 24 hours.
          </p>

          {/* Search bar */}
          <div style={{
            display: "flex", gap: 8, padding: 8, borderRadius: 14,
            background: T.n50, border: `1.5px solid ${searchFocused ? T.g400 : T.n150}`,
            boxShadow: searchFocused ? `0 0 0 4px ${T.g100}` : "0 1px 4px rgba(0,0,0,.04)",
            transition: "all .18s", flexWrap: "wrap",
          }}>
            <div style={{ flex: 1, minWidth: 180, display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: T.white, borderRadius: 10 }}>
              <Icon name="MapPin" size={16} color={T.n400} strokeWidth={1.8} />
              <input
                value={location}
                onChange={e => setLocation(e.target.value)}
                onFocus={() => setSearchFocused(true)}
                onBlur={() => setSearchFocused(false)}
                placeholder="Your area, e.g. Kilimani, Nyali..."
                style={{ flex: 1, border: "none", outline: "none", fontSize: 14, fontFamily: T.sans, color: T.n900, background: "transparent" }}
              />
            </div>
            <button onClick={goToSearch} style={{
              display: "inline-flex", alignItems: "center", gap: 7,
              padding: "12px 22px", background: T.g500, color: T.white,
              border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, whiteSpace: "nowrap",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              <Icon name="Search" size={15} color={T.white} strokeWidth={2} />
              Find Pros
            </button>
          </div>
        </div>
      </div>

      {/* ══ TRUST STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "BadgeCheck", label: "150+ verified cleaning Pros" },
            { icon: "Star",       label: "4.7 average rating across bookings" },
            { icon: "Clock",      label: "Most bookings confirmed within hours" },
          ].map(({ icon, label }, i) => (
            <div key={i} style={{ padding: "20px", display: "flex", alignItems: "center", gap: 11, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={17} color={T.g500} strokeWidth={1.6} />
              <span style={{ fontSize: 13, color: T.n600, lineHeight: 1.4 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ SUB-SERVICES ══ */}
        <div style={{ paddingTop: "clamp(48px,7vw,72px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>What's included</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Every type of clean, <em style={{ fontStyle: "italic", color: T.g600 }}>covered</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            From a weekly tidy-up to a full move-out deep clean. Prices reflect what Pros on the platform are currently charging.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 12 }}>
            {SUBSERVICES.map((s, i) => <SubServiceCard key={i} {...s} />)}
          </div>
        </div>

        {/* ══ HOW IT WORKS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>How it works</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Booked in minutes, <em style={{ fontStyle: "italic", color: T.g600 }}>done right</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            No phone calls, no back-and-forth. Just clear pricing and verified people.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 14 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <div key={i} style={{ padding: "22px", borderRadius: 14, border: `1px solid ${T.n150}`, background: T.n50, display: "flex", gap: 16, alignItems: "flex-start" }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                  background: T.white, border: `1px solid ${T.n150}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <Icon name={step.icon} size={17} color={T.g500} strokeWidth={1.6} />
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.08em", marginBottom: 4 }}>STEP {step.num}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6 }}>{step.title}</div>
                  <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.65, margin: 0 }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24, textAlign: "center" }}>
            <button onClick={goToSearch} style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: T.g500, color: T.white, border: "none",
              padding: "13px 28px", borderRadius: 11, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Browse cleaning Pros near you
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
          </div>
        </div>

        {/* ══ WHY JIRANIAPP ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Why book through JiraniApp</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 24px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Trust, built into <em style={{ fontStyle: "italic", color: T.g600 }}>every booking</em>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 }}>
            {WHY_POINTS.map((item, i) => (
              <div key={i} style={{ padding: "22px", borderRadius: 14, border: `1px solid ${T.n150}`, display: "flex", flexDirection: "column", gap: 12 }}>
                <div style={{ width: 38, height: 38, borderRadius: 10, background: T.g50, border: `1px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon name={item.icon} size={17} color={T.g500} strokeWidth={1.6} />
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.n900 }}>{item.title}</div>
                <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TESTIMONIALS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>From clients</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 24px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What people are <em style={{ fontStyle: "italic", color: T.g600 }}>saying</em>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 14 }}>
            {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} />)}
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Common questions</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Before you <em style={{ fontStyle: "italic", color: T.g600 }}>book</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Everything clients usually ask about cleaning and laundry bookings.
          </p>
          <div>
            {FAQS.map((item, i) => <FaqItem key={i} {...item} />)}
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,56px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.g50, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="Sparkles" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4.5vw,40px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Ready for a cleaner <em style={{ fontStyle: "italic", color: T.g600 }}>space?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 auto 32px", lineHeight: 1.75, maxWidth: 400 }}>
            Compare verified cleaning Pros near you and book in minutes.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={goToSearch} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Find a cleaning Pro
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "14px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              Learn how JiraniApp works
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}